
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/europe/ranking/[franchiseSlug]/[year]",
      function () {
        return require("private-next-pages/europe/ranking/[franchiseSlug]/[year]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/europe/ranking/[franchiseSlug]/[year]"])
      });
    }
  